module.exports = __webpack_public_path__ + "img/img_money.6d45f5ee.png";